import React from "react";
import ChatListItem from "../ChatListItem";
import style from "./ChatListPanel.module.scss";

const ChatListPanel = ({ chats, selectedChat, onSelectChat, loading, loadingText, emptyText }) => {
  if (loading) {
    return (
      <div className={style.chat_list_panel}>
        <div className={style.loading_state}>{loadingText}</div>
      </div>
    );
  }

  if (chats.length === 0) {
    return (
      <div className={style.chat_list_panel}>
        <div className={style.empty_state}>{emptyText}</div>
      </div>
    );
  }

  return (
    <div className={style.chat_list_panel}>
      {chats.map((chat) => (
        <ChatListItem
          key={chat.id}
          chat={chat}
          isActive={selectedChat?.id === chat.id}
          onClick={() => onSelectChat(chat)}
        />
      ))}
    </div>
  );
};

export default ChatListPanel;
